<template>
    <div>
        <b-row>
            <b-col cols="12" md="6" lg="4">
                <b-form-group :label="$t('national_id')">
                    <b-form-input v-model="formData.national_id" :disabled="true" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" lg="4">
                <b-form-group :label="$t('pin')">
                    <b-form-input v-model="formData.pin" :disabled="true" />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'LoginDetailsTab',
    props: {
        formData: {
            type: Object,
            required: true
        }
    }
}
</script>
